module.exports = __webpack_public_path__ + "img/article-icon-108.587e340e.svg";